// EVE-Avatar — circular crop von /eve-satoshi.png mit Amber-Pulse-Ring +
// optional Live-Dot. Größe via prop konfigurierbar (mockup verwendet 96px).

interface EveAvatarProps {
  /** Pixel-Größe — default 96. Topbar verwendet 24. */
  size?: number;
  /** Pulse-Ring anzeigen (default true). */
  pulse?: boolean;
  /** Live-Dot (emerald) unten rechts (default false). */
  liveDot?: boolean;
  className?: string;
}

export function EveAvatar({ size = 96, pulse = true, liveDot = false, className }: EveAvatarProps) {
  const ringClass = pulse ? 'eve-avatar-pulse' : '';
  return (
    <div className={`relative inline-block ${className ?? ''}`}>
      <div
        className={`overflow-hidden rounded-full ring-2 ring-amber-500/50 ${ringClass}`}
        style={{ width: size, height: size }}
      >
        <img
          src="/eve-satoshi.png"
          alt="EVE mit Satoshi"
          className="size-full object-cover"
        />
      </div>
      {liveDot ? (
        <span
          className="absolute right-1 bottom-1 animate-pulse rounded-full bg-emerald-400 ring-2 ring-neutral-950"
          style={{
            width: Math.max(8, Math.round(size * 0.14)),
            height: Math.max(8, Math.round(size * 0.14)),
          }}
          title="Live"
        />
      ) : null}
    </div>
  );
}
